import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { take } from 'rxjs';
import { Actions, ofType } from '@ngrx/effects';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { IFilterCBSAs } from '@shared/models/filters';
import { AccountSetupMarketsComponent } from '@shared/components/auth-modal/account-setup/form/markets/markets.component';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import {
  resetFiltersAction,
  setUnsavedCBSAsFiltersAction,
} from '@state/filters/filters.actions';
import { selectFiltersCurrent } from '@state/filters/filters.selectors';

@UntilDestroy()
@Component({
  selector: 'app-filter-v2-cbsas',
  templateUrl: './filter-v2-cbsas.component.html',
  styleUrls: ['../filters-v2.component.scss'],
})
export class FilterV2CbsasComponent implements OnInit {
  @Output() applyFilters = new EventEmitter();
  @ViewChild('trigger') menuTrigger!: MatMenuTrigger;
  @ViewChild(AccountSetupMarketsComponent)
  marketsComponent!: AccountSetupMarketsComponent;

  protected isOpen = false;
  protected selectedValues: IFilterCBSAs[] = [];
  protected defaultSelectedValues?: IFilterCBSAs[];

  constructor(
    private store: Store<AppState>,
    private actions$: Actions
  ) {}

  ngOnInit(): void {
    this.store
      .select(selectFiltersCurrent)
      .pipe(take(1))
      .subscribe((filters) => {
        this.selectedValues = filters?.CBSAs ?? [];
        this.defaultSelectedValues = filters?.CBSAs ?? [];
      });

    this.actions$
      .pipe(ofType(resetFiltersAction), untilDestroyed(this))
      .subscribe(() => {
        this.resetCbsas();
      });
  }

  onMenuOpened(): void {
    this.isOpen = true;
    if (this.marketsComponent) {
      this.marketsComponent.forceFocus();
    }
  }

  onMenuClosed(): void {
    this.isOpen = false;
  }

  handleSelectedChange(values: IFilterCBSAs[]) {
    this.selectedValues = values;
    this.store.dispatch(setUnsavedCBSAsFiltersAction({ items: values }));
    this.applyFilters.emit();
  }

  resetCbsas() {
    this.selectedValues = [];
    this.defaultSelectedValues = [];
    this.store.dispatch(setUnsavedCBSAsFiltersAction({ items: [] }));
    this.applyFilters.emit();
  }

  closeMenu() {
    this.menuTrigger.closeMenu();
  }
}
